import { render, staticRenderFns } from "./VideoItemHeader.vue?vue&type=template&id=01e0f2b5&scoped=true&"
import script from "./VideoItemHeader.vue?vue&type=script&lang=js&"
export * from "./VideoItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./VideoItemHeader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VideoItemHeader.vue?vue&type=style&index=1&id=01e0f2b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e0f2b5",
  null
  
)

export default component.exports